import { ChevronRight, LayoutDashboard, PanelRightClose } from "@/components/icons"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

type DashboardBreadcrumbProps = {
  className?: string
  dashboardTitle: string
  onBackToList: () => void
  onTogglePanel?: () => void
}

export function DashboardBreadcrumb({
  className,
  dashboardTitle,
  onBackToList,
  onTogglePanel,
}: DashboardBreadcrumbProps) {
  const { t } = useTranslation()

  return (
    <nav
      aria-label={t("dash.dashboard.breadcrumb_label")}
      className={cn("flex min-w-0 items-center gap-1", className)}
    >
      <Button
        className="h-7 shrink-0 gap-1.5 px-2"
        size="sm"
        variant="ghost"
        onClick={onBackToList}
      >
        <LayoutDashboard className="size-3.5" />
        {t("dash.dashboard.module_name")}
      </Button>
      <ChevronRight aria-hidden="true" className="text-muted-foreground size-3.5" />
      <span
        aria-current="page"
        className="text-muted-foreground max-w-48 min-w-0 flex-1 truncate text-xs"
        title={dashboardTitle}
      >
        {dashboardTitle}
      </span>
      {onTogglePanel && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              aria-label={t("dash.dashboard.toggle_dashboard")}
              className="size-7 shrink-0 p-0"
              size="icon"
              variant="ghost"
              onClick={onTogglePanel}
            >
              <PanelRightClose className="size-3.5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t("dash.dashboard.toggle_dashboard")}</TooltipContent>
        </Tooltip>
      )}
    </nav>
  )
}
